import React from 'react'

function OurService() {
  return (
    <>
      <section className="service-section-app pad-tb dark-bg2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="common-heading ptag">
                <span>Service</span>
                <h2>Our Services</h2>
                <p className="mb30">
                  We think big and have hands in all leading technology platforms to provide you
                  wide array of services.
                </p>
              </div>
            </div>
          </div>
          <div className="row upset">
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>App Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">Android</a></li>
                  <li><a href="#">iPhone</a></li>
                  <li><a href="#">Cross Platform</a></li>
                </ul>
                <div className="tec-icon mt30">
                  <ul className="servc-icon-sldr">
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/android.svg" alt="android" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/apple.svg" alt="apple" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/tablet.svg" alt="tablet" /></div></a></li>
                  </ul>
                </div>
                <p className="mt20 flex-grow-1">
                  N D Techland Pvt. Ltd. crafts custom mobile apps for iOS, Android, and cross-platform, prioritizing user experience and scalability.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>Web Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">UI/UX</a></li>
                  <li><a href="#">PHP</a></li>
                  <li><a href="#">Java</a></li>
                  <li><a href="#">WordPress</a></li>
                </ul>
                <div className="tec-icon mt30">
                  <ul className="servc-icon-sldr">
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/ux.svg" alt="ux" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/php.svg" alt="php" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/java.svg" alt="java" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/wordpress.svg" alt="wordpress" /></div></a></li>
                  </ul>
                </div>
                <p className="mt20 flex-grow-1">
                  At N D Techland Pvt. Ltd., we specialize in crafting dynamic websites tailored to your needs, ensuring seamless functionality and user engagement.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>E-Commerce Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">Magento</a></li>
                  <li><a href="#">Shopify</a></li>
                  <li><a href="#">Woo-commerce</a></li>
                </ul>
                <div className="tec-icon mt30">
                  <ul className="servc-icon-sldr">
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/magento.svg" alt="magento" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/shopify.svg" alt="shopify" /></div></a></li>
                    <li><a href="#"><div className="img-iconbb"><img src="images/icons/woocommerce.svg" alt="woocommerce" /></div></a></li>
                  </ul>
                </div>
                <p className="mt20 flex-grow-1">
                  N D Techland Pvt. Ltd. excels in eCommerce development, creating robust online platforms that drive sales, enhance user experience and foster growth.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default OurService